import { fetchApi } from "@/utils/axios";

const prefix = "/api/ds-ai-server";

// ========== 热门问题管理 ==========
// 查询热门问题列表
export function getPopularQuestionList(data) {
  return fetchApi(`${prefix}/web/questions/hot/list`, data, "post", "data");
}

// 根据ID查询热门问题详情
export function getPopularQuestionDetail(id) {
  return fetchApi(`${prefix}/web/questions/hot/${id}`, {}, "get", "params");
}

// 新增热门问题
export function addPopularQuestion(data) {
  return fetchApi(`${prefix}/web/questions/hot`, data, "post", "data");
}

// 更新热门问题
export function updatePopularQuestion(data) {
  return fetchApi(`${prefix}/web/questions/hot`, data, "put", "data");
}

// 删除热门问题
export function deletePopularQuestion(id) {
  return fetchApi(`${prefix}/web/questions/hot/${id}`, {}, "delete");
}

// 更新热门问题状态（启用/禁用）
export function updatePopularQuestionStatus(id, status) {
  return fetchApi(`${prefix}/web/questions/hot/${id}/status`, { status }, "put", "data");
}

// ========== 未知问题管理 ==========
// 获取未知问题统计指标
export function getUnknownIssueStatistics() {
  return fetchApi(`${prefix}/web/questions/unknown-statistics`, {}, "get", "params");
}

// 查询未知问题列表
export function getUnknownIssueList(data) {
  return fetchApi(`${prefix}/web/questions/unknown-list`, data, "post", "data");
}

// 更新未知问题状态（标记已处理 / 忽略）
export function updateUnknownIssueStatus(data) {
  return fetchApi(
    `${prefix}/web/questions/unknown/${data.id}/status/${data.status}`,
    {},
    "put"
  );
}

// ========== 服务卡片管理 ==========
const chataiPrefix = "/api/ds-ai-server";

// 查询服务卡片列表
export function getServiceCardList(params) {
  return fetchApi(`${chataiPrefix}/web/recommend-card/page`, params, "get", "params");
}

// 查询服务卡片详情
export function getServiceCardDetail(id) {
  return fetchApi(`${chataiPrefix}/web/recommend-card/get`, { id }, "get", "params");
}

// 更新服务卡片状态
export function updateServiceCardStatus(data) {
  return fetchApi(`${chataiPrefix}/web/recommend-card/status`, data, "put", "data");
}

// 新增服务卡片
export function addServiceCard(data) {
  return fetchApi(`${chataiPrefix}/web/recommend-card/create`, data, "post", "data");
}

// 更新服务卡片
export function updateServiceCard(data) {
  return fetchApi(`${chataiPrefix}/web/recommend-card/update`, data, "put", "data");
}

// 删除服务卡片
export function deleteServiceCard(id) {
  return fetchApi(`${chataiPrefix}/web/recommend-card/delete?id=${id}`, {}, "delete", "params");
}

// ========== 提示词模板管理 ==========
// 查询提示词模板列表（分页）
export function getPromptTemplateList(data) {
  return fetchApi(`${prefix}/web/prompt/template/list`, data, "post", "data");
}

// 创建提示词模板
export function createPromptTemplate(data) {
  return fetchApi(`${prefix}/web/prompt/template`, data, "post", "data");
}

// 编辑提示词模板
export function updatePromptTemplate(data) {
  return fetchApi(`${prefix}/web/prompt/template`, data, "put", "data");
}

// 启用/禁用提示词模板
export function updatePromptTemplateStatus(id, status) {
  return fetchApi(`${prefix}/web/prompt/template/${id}/status?status=${status}`, {}, "put", "params");
}

// 删除提示词模板
export function deletePromptTemplate(id) {
  return fetchApi(`${prefix}/web/prompt/template?id=${id}`, {}, "delete", "params");
}

// 创建提示词版本
export function createPromptVersion(data) {
  return fetchApi(`${prefix}/web/prompt/version`, data, "post", "data");
}

// 编辑提示词版本
export function updatePromptVersion(data) {
  return fetchApi(`${prefix}/web/prompt/version`, data, "put", "data");
}

// 查询提示词版本列表（分页）
export function getPromptVersionList(data) {
  return fetchApi(`${prefix}/web/prompt/version/list`, data, "post", "data");
}

// 删除提示词版本
export function deletePromptVersion(id) {
  return fetchApi(`${prefix}/web/prompt/version?id=${id}`, {}, "delete", "params");
}

// 后端网关未返回禁缓存头，知识库模块的 GET 查询统一追加时间戳，
// 避免浏览器对相同 URL 的查询结果做启发式缓存、增删改后读到旧列表
const withNoCache = (params = {}) => ({ ...params, _t: Date.now() });

// ========== 知识库管理 ==========
// 分页查询知识库列表（名称/状态筛选）
export function getKnowledgePage(params) {
  return fetchApi(`${prefix}/web/knowledge/page`, withNoCache(params), "get", "params");
}

// 查询知识库详情
export function getKnowledgeDetail(id) {
  return fetchApi(`${prefix}/web/knowledge/get`, withNoCache({ id }), "get", "params");
}

// 创建知识库（name/refCode/topK/similarityThreshold/status 必填，description 选填）
export function createKnowledge(data) {
  return fetchApi(`${prefix}/web/knowledge/create`, data, "post", "data");
}

// 更新知识库（id + 同创建字段）
export function updateKnowledge(data) {
  return fetchApi(`${prefix}/web/knowledge/update`, data, "put", "data");
}

// 更新知识库状态（独立启停接口，0=开启，1=关闭）
export function updateKnowledgeStatus(data) {
  return fetchApi(`${prefix}/web/knowledge/update-status`, data, "put", "data");
}

// 删除知识库（联动删除库内文档）
export function deleteKnowledge(id) {
  return fetchApi(`${prefix}/web/knowledge/delete?id=${id}`, {}, "delete", "params");
}

// 查询业务类型列表（两段式：服务领域/业务类型，业务类型编码即 refCode）
export function getBizTypeList() {
  return fetchApi(`${prefix}/web/knowledge/biz-type/list`, withNoCache(), "get", "params");
}

// 创建业务类型（domainName 不存在时自动新建领域；编码由后端自动生成）
export function createBizType(data) {
  return fetchApi(`${prefix}/web/knowledge/biz-type/create`, data, "post", "data");
}

// 分页查询知识库文档列表（knowledgeId + refCode 筛选）
export function getDocumentPage(params) {
  return fetchApi(`${prefix}/web/knowledge/document/page`, withNoCache(params), "get", "params");
}

// 查询知识库文档详情
export function getDocumentDetail(id) {
  return fetchApi(`${prefix}/web/knowledge/document/get`, withNoCache({ id }), "get", "params");
}

// 更新知识库文档（仅 refCode/description/documentType/segmentMaxTokens 可改，
// 后三者变更会触发向量库全量重建）
export function updateDocument(data) {
  return fetchApi(`${prefix}/web/knowledge/document/update`, data, "put", "data");
}

// 更新知识库文档状态（0=开启，1=关闭）
export function updateDocumentStatus(data) {
  return fetchApi(`${prefix}/web/knowledge/document/update-status`, data, "put", "data");
}

// 删除知识库文档（同步清除向量数据）
export function deleteDocument(id) {
  return fetchApi(`${prefix}/web/knowledge/document/delete?id=${id}`, {}, "delete", "params");
}

// 按网页链接创建文档（knowledgeId/refCode/url/segmentMaxTokens 必填，description 选填）
export function createDocument(data) {
  return fetchApi(`${prefix}/web/knowledge/document/create`, data, "post", "data");
}

// 上传本地文件创建文档（multipart：file + knowledgeId/refCode/segmentMaxTokens/description）
export function uploadDocument(formData) {
  return fetchApi(`${prefix}/web/knowledge/document/upload`, formData, "post", "data");
}

// ========== 分块管理 ==========
// 分页查询文档分块列表（documentId 必填，keyword/status 筛选）
export function getSegmentPage(params) {
  return fetchApi(`${prefix}/web/knowledge/segment/page`, withNoCache(params), "get", "params");
}

// 查询分块详情
export function getSegmentDetail(id) {
  return fetchApi(`${prefix}/web/knowledge/segment/get`, withNoCache({ id }), "get", "params");
}

// 更新分块状态（0=开启，1=关闭）
export function updateSegmentStatus(data) {
  return fetchApi(`${prefix}/web/knowledge/segment/update-status`, data, "put", "data");
}

// 查询文档分块统计（分块总数/停用数/累计召回次数）
export function getSegmentStats(documentId) {
  return fetchApi(
    `${prefix}/web/knowledge/segment/stats`,
    withNoCache({ documentId }),
    "get",
    "params"
  );
}
